import Vue from 'vue'
import moment from 'moment'

moment.locale(process.env.VUE_APP_LOCALE);

Vue.prototype.$moment = moment
